export const VALORES_CLAVE = {
  A: "A",
  B: "B",
}

export const VALORES_SUBCLAVE = {
  UNO: "01",
  DOS: "02",
  TRES: "03",
  CUATRO: "04",
  CINCO: "05",
}
